import React from 'react';

const ChildCard = ({
  child,
  index,
  currentTask,
  elapsed,
  progress,
  currentWinner,
  isDone,
  isWin,
  isShake,
  onComplete,
}) => (
  <div className={`child ${isWin ? 'win' : ''} ${isShake ? 'shake' : ''}`}>
    <div className="child-head">
      <div className="identity">
        <div className="avatar">{child.avatar}</div>
        <div className="namebox">
          <div className="name">{child.name}</div>
          <div className="points">
            ⭐ {child.points} point
            {child.wins ? ` · 🏅 ${child.wins} sejre` : ''}
          </div>
        </div>
      </div>
      <div className={`badge ${currentWinner ? 'win' : isDone ? 'done' : 'wait'}`}>{currentWinner ? 'Vinder' : isDone ? 'Færdig' : 'Klar'}</div>
    </div>

    <div className="child-body">
      <div className={`current-card ${isDone ? 'pop' : ''}`}>
        {isDone && (
          <>
            <div className="current-icon">🎉</div>
            <div className="current-title">Færdig!</div>
            <div className="current-note">Flot klaret, {child.name}</div>
          </>
        )}

        {currentTask && (
          <>
            <div className="current-icon">{currentTask.icon}</div>
            <div className="current-title">{currentTask.title}</div>
            <div className="current-time">⏱ {elapsed}</div>
            <div className="current-note">{child.name}, fortsæt i dit eget tempo</div>
          </>
        )}
      </div>

      {isDone ? (
        <button className="action-btn secondary" disabled>
          Mission færdig
        </button>
      ) : (
        <button className="action-btn" onClick={onComplete}>
          Færdig
        </button>
      )}

      <div className="progress">
        <div className="track">
          <div className="bar" style={{ width: `${progress}%` }} />
        </div>
        <div className="pct">{Math.round(progress)}%</div>
      </div>

      <div className="done-list">
        {!child.done.length && <div className="done-title">Ingen opgaver endnu</div>}
        {!!child.done.length && <div className="done-title">Færdige opgaver</div>}
        {child.done.map((item, i) => (
          <div className="done-item" key={`${item.title}-${index}-${i}`}>
            <div className="emoji">{item.icon}</div>
            <div className="text">
              <div>{item.title}</div>
              <span className="time">
                +{item.pointsAwarded || 0} point · {item.time} · {item.note}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ChildCard;
